//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

/** Progress status */
export enum ProgressStatus {
	/** The customer has not started yet */
	NotStarted = 0,
	/** The customer is in progress */
	InProgress = 1,
	/** The customer has completed the game */
	Completed = 2
}
